// @flow
import * as React from 'react';

import SelectorDropdownExample from './SelectorDropdownExample';
import SelectorDropdown from './SelectorDropdown';
import notes from './SelectorDropdown.stories.md';

export const basic = () => <SelectorDropdownExample />;

export default {
    title: 'Components/SelectorDropdown',
    component: SelectorDropdown,
    parameters: {
        notes,
    },
};
